import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment from 'moment';
import { AccountData } from './types';

export const buildProfileUpdateBody = (
  formData: AccountData,
  timeStart: MaterialUiPickersDate,
) => {
  const { client, project, personalId, employer, externalEmployeeId } =
    formData;
  return {
    client: client ? { name: client.name, id: client.value } : null,
    project: project ? { name: project.name, id: project.value } : null,
    startTime: timeStart ? moment(timeStart).format('HH:mm') : '08:00',
    employer: employer ? { name: employer.name, id: employer.value } : null,
    personalId: personalId || null,
    externalEmployeeId: externalEmployeeId || null,
  };
};
